import templateUrl from "./nav-sidebar.html"
import './nav-sidebar.less'

import { EditFeedbackModal } from '../feedback/edit-feedback-modal.component'

export const NavSidebarComponent = {
    controller: NavSidebarController,
    controllerAs: "nav",
    templateUrl,
    bindings: {
        identity: "<",
        navigationModules: "<",
        onChangeSecurityItem: "&"
    }
}

function NavSidebarController($state, $transitions, $uibModal, apexDeployStage) {
    'ngInject'
    const vm = this;
    vm.state = $state.current;
    vm.apexDeployStage = apexDeployStage;
    vm.identity;
    vm.navigationModules;
    vm.isInState = isInState;
    vm.onAccountOptionsClick = onAccountOptionsClick;
    vm.onChangeSecurityItem;
    vm.onSendFeedbackClick = onSendFeedbackClick;
    vm.onToggleExpandModule = onToggleExpandModule;

    vm.$onInit = function () {
        if (vm.navigationModules) {
            expandSelectedMenuItem(vm.navigationModules);
        }
        addTransitionHandlers();
    };
    vm.$onChanges = function (changes) {
        if (changes.navigationModules && vm.navigationModules) {
            expandSelectedMenuItem(vm.navigationModules);
        }
    }

    function expandSelectedMenuItem(navigationModules) {
        navigationModules.forEach(function (module) {
            module.SecurityItems.forEach(function (securityItem) {
                if (isInState(securityItem.StateName)) {
                    module.expanded = true;
                }
            });
        })
    }

    function onAccountOptionsClick() {
        vm.accountOptionsOpen = !vm.accountOptionsOpen;
    }

    function onToggleExpandModule(module) {
        vm.navigationModules.forEach(function (_module) {
            // Expand only one at a time.
            if (_module !== module) {
                _module.expanded = false;
            } else {
                _module.expanded = !_module.expanded;
            }
        });
    }

    function onSendFeedbackClick() {
        $uibModal.open(EditFeedbackModal).result.then(function () {
            alert("Feedback successfully sent.");
        }).catch(() => {});
    }

    /**
     * Return whether the application is in the given state.
     * @param {string} stateName The state name to check against the current state.
     */
    function isInState(stateName) {
        const currentState = $state.current.name;
        // Match the state if the current state is child of the given state.
        // Note that some states are declared under the a parent prefix, so
        // they may not appear specifically at index 0.
        return currentState.indexOf(stateName) > -1;
    }

    function addTransitionHandlers() {
        $transitions.onSuccess({}, transition => {
            vm.state = transition.$to();
            if (vm.navigationModules) {
                expandSelectedMenuItem(vm.navigationModules);
            }
        })
    }
}
